import _ from 'lodash';

import Config from '@skin_config';

export const hasProfitBoost = (bet, stakeAmount) => {
  console.log(Config.wheelConfig,'sdfoidi', bet, stakeAmount)
  return (
  Config.wheelConfig.enableWheel
    && bet.selection_list.length >= Config.wheelConfig.minSelectionsCount
    && bet.selection_list.filter((item) => item.price > Config.wheelConfig.minSelectionOdd).length === bet.selection_list.length
    && _.inRange(bet.price, Config.wheelConfig.minOdd, 100000000000000000)
    && _.inRange(stakeAmount, Config.wheelConfig.minStake, Config.wheelConfig.maxStake)
    && _.inRange(bet.price, Config.wheelConfig.minOdd, Config.wheelConfig.maxOdd)
);

}